import { Injectable } from "@angular/core";
import { DashboardReport } from "../../shared/enums/dashboardReports";

@Injectable({
  providedIn: "root",
})
export class DashboardLayoutSettingService {
  dashboradReports1 = [
    {
      id: 1,
      name: DashboardReport.OrdersWrittenthismonth,
      status: false,
    },
    {
      id: 2,
      name: DashboardReport.OrdersBilledInvoiced,
      status: false,
    },
    {
      id: 3,
      name: DashboardReport.OrdersbyInHandsdate,
      status: false,
    },
    {
      id: 4,
      name: DashboardReport.CustomerAging,
      status: false,
    },
    {
      id: 8,
      name: DashboardReport.ReadyToBill,
      status: true,
    },
    {
      id: 5,
      name: DashboardReport.CustomerYearOverYear,
      status: true,
    },
    {
      id: 6,
      name: DashboardReport.TopClients,
      status: true,
    },
    {
      id: 7,
      name: DashboardReport.MyOpenPOs,
      status: true,
    },
    {
      id: 9,
      name: DashboardReport.OrderDetail,
      status: true,
    },
    {
      id: 10,
      name: DashboardReport.CustomerwithDepositsandPrebills,
      status: true,
    },
    {
      id: 11,
      name: DashboardReport.TasksbyDueDate,
      status: true,
    },
    {
      id: 12,
      name: DashboardReport.ArAging,
      status: false,
    },
    {
      id: 13,
      name: DashboardReport.ReadyToBillReport,
      status: false,
    },
  ];

  dashboradReports2 = [
    {
      id: 1,
      name: DashboardReport.OrdersWrittenthismonth,
      status: false,
    },
    {
      id: 2,
      name: DashboardReport.OrdersBilledInvoiced,
      status: false,
    },
    {
      id: 3,
      name: DashboardReport.OrdersbyInHandsdate,
      status: false,
    },
    {
      id: 4,
      name: DashboardReport.CustomerAging,
      status: false,
    },
    {
      id: 8,
      name: DashboardReport.ReadyToBill,
      status: true,
    },
    {
      id: 5,
      name: DashboardReport.CustomerYearOverYear,
      status: true,
    },
    {
      id: 6,
      name: DashboardReport.TopClients,
      status: true,
    },
    {
      id: 7,
      name: DashboardReport.MyOpenPOs,
      status: true,
    },
    {
      id: 9,
      name: DashboardReport.OrderDetail,
      status: true,
    },
    {
      id: 10,
      name: DashboardReport.CustomerwithDepositsandPrebills,
      status: true,
    },
    {
      id: 11,
      name: DashboardReport.TasksbyDueDate,
      status: true,
    },
    {
      id: 12,
      name: DashboardReport.ArAging,
      status: false,
    },
    {
      id: 13,
      name: DashboardReport.ReadyToBillReport,
      status: false,
    },
  ];

  dashboradReports3 = [
    {
      id: 1,
      name: DashboardReport.OrdersWrittenthismonth,
      status: false,
    },
    {
      id: 2,
      name: DashboardReport.OrdersBilledInvoiced,
      status: false,
    },
    {
      id: 3,
      name: DashboardReport.OrdersbyInHandsdate,
      status: false,
    },
    {
      id: 4,
      name: DashboardReport.CustomerAging,
      status: false,
    },
    {
      id: 8,
      name: DashboardReport.ReadyToBill,
      status: true,
    },
    {
      id: 5,
      name: DashboardReport.CustomerYearOverYear,
      status: true,
    },
    {
      id: 6,
      name: DashboardReport.TopClients,
      status: true,
    },
    {
      id: 7,
      name: DashboardReport.MyOpenPOs,
      status: true,
    },
    {
      id: 9,
      name: DashboardReport.OrderDetail,
      status: true,
    },
    {
      id: 10,
      name: DashboardReport.CustomerwithDepositsandPrebills,
      status: true,
    },
    {
      id: 11,
      name: DashboardReport.TasksbyDueDate,
      status: true,
    },
    {
      id: 12,
      name: DashboardReport.ArAging,
      status: false,
    },
    {
      id: 13,
      name: DashboardReport.ReadyToBillReport,
      status: false,
    },
  ];

  dashboradReports4 = [
    {
      id: 1,
      name: DashboardReport.OrdersWrittenthismonth,
      status: false,
    },
    {
      id: 2,
      name: DashboardReport.OrdersBilledInvoiced,
      status: false,
    },
    {
      id: 3,
      name: DashboardReport.OrdersbyInHandsdate,
      status: false,
    },
    {
      id: 4,
      name: DashboardReport.CustomerAging,
      status: false,
    },
    {
      id: 8,
      name: DashboardReport.ReadyToBill,
      status: true,
    },
    {
      id: 5,
      name: DashboardReport.CustomerYearOverYear,
      status: true,
    },
    {
      id: 6,
      name: DashboardReport.TopClients,
      status: true,
    },
    {
      id: 7,
      name: DashboardReport.MyOpenPOs,
      status: true,
    },
    {
      id: 9,
      name: DashboardReport.OrderDetail,
      status: true,
    },
    {
      id: 10,
      name: DashboardReport.CustomerwithDepositsandPrebills,
      status: true,
    },
    {
      id: 11,
      name: DashboardReport.TasksbyDueDate,
      status: true,
    },
    {
      id: 12,
      name: DashboardReport.ArAging,
      status: false,
    },
    {
      id: 13,
      name: DashboardReport.ReadyToBillReport,
      status: false,
    },
  ];
}
